// @flow
import axios from 'axios';

export const ANSWER_QUESTION = 'ANSWER_QUESTION';
export const FETCH_QUESTIONNAIRE_DATA = 'FETCH_QUESTIONNAIRE_DATA';
export const HEALTH_CHECK_COMPUTE_QAs = 'FETCH_HISTORY_ITEMS';
export const SUBMIT_QUESTIONNAIRE = 'SUBMIT_QUESTIONNAIRE';

export function fetchQuestionnaireDate(field_id) {
  return {
    type: FETCH_QUESTIONNAIRE_DATA,
    payload: axios.get(`/${field_id}/health_check/health_check_json`)
      .then(response => response.data.data)
      .catch((error) => { console.log('HEALTH_CHECK_ERROR:::', error); }),
  };
}

export function selectAnswer(question_id, value) {
  return {
    type: ANSWER_QUESTION,
    payload: {
      question_id,
      value,
    },
  };
}

export function submitQuestionnaire(payload, field_id) {
  return {
    type: SUBMIT_QUESTIONNAIRE,
    payload: axios.post(`/${field_id}/project-health-check`, payload)
      .then(res => res.data)
      .catch(error => error),
  };
}
